import { render, staticRenderFns } from "./actor-restrictions.vue?vue&type=template&id=682abf04&scoped=true&"
import script from "./actor-restrictions.vue?vue&type=script&lang=ts&"
export * from "./actor-restrictions.vue?vue&type=script&lang=ts&"
import style0 from "./actor-restrictions.vue?vue&type=style&index=0&id=682abf04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682abf04",
  null
  
)

export default component.exports